import React, { useState, useEffect } from 'react';
import GameTabs from './Games/GameTabs';
import Profile from './Profile/Profile';
import Log from './Log/Log';
import getGameType from '../../utils/games';
import { getGameImage } from '../../utils/getGameImage';
import LoadingPng from '../../assets/images/Loading.png';
import UserManagement from './UserManagement/UserManagement';

export default function UpdateUserTabs({
  userId,
  userTab,
  games,
  allGameSettings,
  userData,
}) {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const processGameData = () => {
    if (!games.length || !allGameSettings.length) return [];

    return games.map((game) => {
      const gameSetting = allGameSettings.find(
        (gs) => gs.id === game.game_settings_id
      );
      const gameType = gameSetting
        ? getGameType(gameSetting.otherSettings?.image)
        : 'Other';
      const GameImage = getGameImage(gameType);
      return {
        id: game.id,
        icon: GameImage,
        name: game.name,
        reference: game.description,
        rates: {
          amount: parseFloat(game.winRate),
          percentage: parseFloat(game.commissionRate),
        },
        win: parseFloat(game.winRate),
        commission: parseFloat(game.commissionRate),
        doubleWin: parseFloat(game.doubleWin),
        tripleWin: parseFloat(game.tripleWin),
        drawTimes: gameSetting?.otherSettings?.drawTime || [],
        cutoffTimes: gameSetting?.otherSettings?.cutOffTime || [],
        isActive: game.active,
        gameType,
        user_game_active: game.user_game_active,
        userId: userId,
        selectedUserId: userId,
      };
    });
  };

  const generateTabsData = (processedGames) => {
    const grouped = processedGames.reduce((acc, game) => {
      const type = game.gameType;
      if (!acc[type]) acc[type] = [];
      acc[type].push(game);
      return acc;
    }, {});

    return [
      { title: 'All', cards: processedGames },
      ...Object.entries(grouped).map(([title, cards]) => ({ title, cards })),
    ];
  };

  const processedGames = processGameData();
  const dynamicTabsData = generateTabsData(processedGames);

  return (
    <div className='px-4'>
      {loading && (
        <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-75'>
          <img
            src={LoadingPng}
            alt='Loading'
            className='w-16 h-16 animate-spin'
          />
        </div>
      )}
      {/* Wrapper div for the full-width background color */}

      {/* Tab Headers */}
      <div
        className={`flex justify-between text-center rounded-md bg-[#E1E7EF] p-1  text-sm `}
      >
        {userTab.concat('User Management').map((child, index) => (
          <button
            key={index}
            className={`  ${
              activeTab === index
                ? 'bg-white text-[#0E64D1] rounded-[4px] px-4 py-2 active-box-shadow flex-1'
                : 'text-[#65758B] px-4 py-2 flex-1'
            } `}
            onClick={() => setActiveTab(index)}
          >
            {child}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 0 && (
          <>
            <GameTabs tabsData={dynamicTabsData}></GameTabs>
          </>
        )}
        {activeTab === 1 && (
          <>
            <Profile userData={userData} />{' '}
          </>
        )}
        {activeTab === 2 && (
          <>
            {' '}
            <Log />{' '}
          </>
        )}
        {activeTab === 3 && (
          <UserManagement userId={userId} userData={userData} />
        )}
      </div>
    </div>
  );
}
